import { InfoCircleOutlined} from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useSendErrorMutation } from 'src/redux/api/error';
import { clearError, getError, setError } from 'src/redux/slices/error';
import { HeaderModalCustom } from 'src/screens/shared/Styles';
import { notifySuccess } from 'src/utils/notificationHelpers';

const ErrorModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { error } = useSelector(getError);
  const [sendError, { isLoading }] = useSendErrorMutation();
  const [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    setTimeLeft(10);
  }, [error.id]);

  useEffect(() => {
    if(timeLeft === 0) {
      setTimeLeft(null);
      dispatch(setError({ id: null } ));
    }

    if (!timeLeft) return;

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft, dispatch]);

  const handleClose = () => {
    dispatch(setError({ id: null } ));
  };

  const handleSendReport = () => {
    if (error?.id) {
      sendError(error).unwrap()
        .then(() => {
          notifySuccess(t('layout:error_report_sent'));
          dispatch(clearError());
        })
        .catch((error) => {
          if (error.originalStatus === 200) {
            notifySuccess(t('layout:error_report_sent'));
            dispatch(clearError());
          }
        });
    }
  };

  return ( error?.id ?
    <Modal
        onCancel={handleClose}
        open={true}
        maskClosable={false}
        transitionName="fade"
        title={
          <HeaderModalCustom>
            <div>
              <h3>
              <InfoCircleOutlined />
                {t('layout:error_modal_title')}
              </h3>
            </div>
          </HeaderModalCustom>
        }
        footer={[
          <Button
            key='discard'
            onClick={handleClose}
            size="large"
          >
            {t('buttons:close')}
          </Button>,
          <Button
            key='save'
            type="primary"
            onClick={handleSendReport}
            size="large"
            loading={isLoading}
            disabled={isLoading}
          >
            {t('layout:send_report')} ({timeLeft})
          </Button>
        ]}
        width='400px'
      >
        <p>{t('layout:error_modal_description')}</p>
        <p>{`${t('layout:error_id')}: ${error.id}`}</p>
    </Modal> : null
  );
};

export default ErrorModal;